<template>
  <div>
    <SelosRegistro v-if="!seloVinculador && !edicaoVinculacao.seloVinculador && !edicaoVinculacao.dataVinculacao"
                   :prop-registro-id="propRegistroId"
                   @listaSelos="listaSelos"
                   @changeSeloVinculador="changeSeloVinculador" />

    <SelosVinculados v-if="selos.length > 0 && !seloVinculador && !edicaoVinculacao.seloVinculador && !edicaoVinculacao.dataVinculacao"
                     :prop-registro-id="propRegistroId"
                     :prop-habilitacao="propHabilitacao"
                     :prop-open-window-editar-vinculacao="openWindowEditarVinculacao"
                     @editar="editarVinculacao"
                     @vincularHabilitacao="changeHabilitacao" />

    <VincularSelos v-if="seloVinculador && !edicaoVinculacao.seloVinculador && !edicaoVinculacao.dataVinculacao"
                   :prop-registro-id="propRegistroId"
                   :prop-selo-vinculador="seloVinculador"
                   :prop-cpf-registrado="propCpfRegistrado"
                   :prop-nome-registrado="propNomeRegistrado"
                   :prop-habilitacao="habilitacao"
                   @voltar="voltar"
                   @finalizadoVinculacoes="finalizadoVinculacoes" />

    <EdicaoVinculacoes v-if="edicaoVinculacao.seloVinculador && edicaoVinculacao.dataVinculacao"
                       :prop-registro-id="propRegistroId"
                       :prop-cpf-registrado="propCpfRegistrado"
                       :prop-nome-registrado="propNomeRegistrado"
                       :prop-data-vinculacao="edicaoVinculacao.dataVinculacao"
                       :prop-selo-vinculador="edicaoVinculacao.seloVinculador"
                       @voltarParaTelaInicial="voltarParaTelaInicial" />
  </div>
</template>

<script>
  /* components */
  import SelosRegistro from '@/components/SofiaRei/Resumo/Selo/SelosRegistro'
  import VincularSelos from '@/components/SofiaRei/Resumo/Selo/VincularSelos'
  import SelosVinculados from '@/components/SofiaRei/Resumo/Selo/SelosVinculados'
  import EdicaoVinculacoes from '@/components/SofiaRei/Resumo/Selo/EdicaoVinculacoes'

  export default {
    name: 'ResumoSelos',
    components: {
      SelosRegistro,
      SelosVinculados,
      VincularSelos,
      EdicaoVinculacoes
    },
    props: {
      propRegistroId: { type: Number, default: () => null },
      propCpfRegistrado: { type: String, default: () => null },
      propNomeRegistrado: { type: String, default: () => null },
      propHabilitacao: { type: Object, default: () => null },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null }
    },
    data () {
      return {
        selos: [],
        seloVinculador: null,
        edicaoVinculacao: {
          seloVinculador: null,
          dataVinculacao: null
        },
        habilitacao: null,
        openWindowEditarVinculacao: null,
      }
    },
    beforeMount () {
      this.openWindowEditarVinculacao  = this.propOpenWindowEditarVinculacao
    },
    methods: {
      listaSelos (listaSelos = []) {
        this.selos = listaSelos
      },

      changeSeloVinculador (seloVinculador = null) {
        this.seloVinculador = seloVinculador
      },

      voltar () {
        this.seloVinculador = null
        this.openWindowEditarVinculacao = null
      },

      finalizadoVinculacoes () {
        this.selos = []
        this.seloVinculador = null
      },

      editarVinculacao ({ seloVinculador, dataVinculacao }) {
        this.edicaoVinculacao = {
          seloVinculador,
          dataVinculacao
        }
      },

      voltarParaTelaInicial () {
        this.edicaoVinculacao = {
          seloVinculador: null,
          dataVinculacao: null
        }

        this.openWindowEditarVinculacao = null
      },
      changeHabilitacao (habilitacao) {
        this.habilitacao = habilitacao
      }
    }
  }
</script>
